import { ReactNode } from "react";

import { css } from "@compiled/react";

import { AtlassianLogo } from "@atlaskit/logo";
import { media } from "@atlaskit/primitives/responsive";
import { B300, N800 } from "@atlaskit/theme/colors";

import { fontSize } from "@/components/signup/utils/font-size";

const signupModule = css({
    alignItems: "center",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    fontFamily: "var(--atlassian-recommended-system-fonts)",
    fontSize: fontSize.sm,
    padding: "2rem 2rem",

    [media.below.sm]: {
        padding: "2rem 0.5rem"
    },
    [media.only.xs]: {
        padding: "2rem 1rem"
    },
    [media.only.sm]: {
        padding: "2rem 1rem"
    }
});

const container = css({
    "maxWidth": "29rem",
    "width": "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h1, h2": {
        fontFamily: "var(--atlassian-recommended-system-fonts)", // needed to override index.css
        textAlign: "center"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h1": {
        fontSize: fontSize.xl,
        fontWeight: 600,
        lineHeight: 1.15,
        margin: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h2": {
        "fontSize": "inherit",
        "fontWeight": "normal",
        "margin": "0.5rem 0 0.5rem",

        "@media (min-width: 376px)": {
            marginBlockEnd: "1.5rem"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h2, p, label, small": {
        color: N800
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "p": {
        lineHeight: 1.5,
        margin: "1rem 0"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label, small": {
        fontSize: fontSize.xs
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "a": {
        "textDecoration": "none",
        "color": B300,

        "&:visited": {
            color: B300
        },

        "&:hover, &:focus": {
            textDecoration: "underline"
        }
    }
});

const footer = css({
    margin: "1.5rem auto 0"
});

export interface SignupModuleWrapperProps {
    fullPage?: boolean;
    hideFooter?: boolean;
    children: ReactNode;
}

export const EmbeddedSignupFormWrapper = ({
    hideFooter,
    children
}: SignupModuleWrapperProps) => {
    return (
        <div css={signupModule}>
            <div css={container}>{children}</div>
            {!hideFooter && (
                <div css={footer}>
                    <AtlassianLogo
                        appearance="brand"
                        size="small"
                        testId="atlassian-logo"
                        label="Atlassian logo"
                    />
                </div>
            )}
        </div>
    );
};
